/* eslint-disable */
/**
 * @audioItems {Array<{
 *    title: String,        // optional, 音频标题
 *    duration: Number,     // optional, 整个媒体文件的播放时长，以秒为单位
 *    initialTime: Number,  // optional, 指定媒体的开始时间，单位为秒; 默认为 0
 *    cover: String,        // optional, 音频封面
 *    poster: String,       // optional, 规定视频正在下载时显示的图像，直到用户点击播放按钮
 *    src: String,          // required, 音频地址
 *    extensionName: string, // optional, 音频文件扩展名, 默认 .mp3
 *    autoplay: Boolean,    // optional, 是否自动播放; 默认 true
 *    muted: Boolean,       // optional, 设置静音或者消除静音; 默认为 false
 *    loop: Boolean,        // optional, 是否循环播放; 默认为 false
 *    volume: Number,       // optional, 在 0.0 到 1.0 之间设置音频音量的相对值，或者查询当前音量相对值; 默认为 1.0
 *    autobuffer: Boolean   // optional, 通知播放器在媒体文件开始播放前，是否进行缓冲加载; 默认为 false
 *    playbackRate: Boolean // optional, 用于指定媒体播放的速度。1.0 表示正常速度，大于 1 则表示`快进`，0 ~ 1 之间表示`慢放`，负值表示回放; 默认为 1
 * }>}
 *
 * @options {Object{
 *    onloadstart: function () {},      // 开始加载音频和视频。
 *    ondurationchange: function () {}, // 音频和视频的duration属性（时长）发生变化时触发，即已经知道媒体文件的长度。如果没有指定音频和视频文件，duration属性等于NaN。如果播放流媒体文件，没有明确的结束时间，duration属性等于Inf（Infinity）。
 *    onloadedmetadata: function () {}, // 媒体文件的元数据加载完毕时触发，元数据包括duration（时长）、dimensions（大小，视频独有）和文字轨。
 *    onloadeddata: function () {},     // 媒体文件的第一帧加载完毕时触发，此时整个文件还没有加载完。
 *    onprogress: function () {},       // 浏览器正在下载媒体文件，周期性触发。下载信息保存在元素的buffered属性中。
 *    oncanplay: function () {},        // 浏览器准备好播放，即使只有几帧，readyState属性变为CAN_PLAY。
 *    oncanplaythrough: function () {}, // 浏览器认为可以不缓冲（buffering）播放时触发，即当前下载速度保持不低于播放速度，readyState属性变为CAN_PLAY_THROUGH。
 *    onabort: function () {},          // 播放中断
 *    onemptied: function () {},        // 媒体文件加载后又被清空，比如加载后又调用load方法重新加载。
 *    onended: function () {},          // 播放结束
 *    onerror: function () {},          // 发生错误。该元素的error属性包含更多信息。
 *    onpause: function () {},          // 播放暂停
 *    onplay: function () {},           // 暂停后重新开始播放
 *    onplaying: function () {},        // 开始播放，包括第一次播放、暂停后播放、结束后重新播放。
 *    onratechange: function () {},     // 播放速率改变
 *    onseeked: function () {},         // 搜索操作结束
 *    onseeking: function () {},        // 搜索操作开始
 *    onstalled: function () {},        // 浏览器开始尝试读取媒体文件，但是没有如预期那样获取数据
 *    onsuspend: function () {},        // 加载文件停止，有可能是播放结束，也有可能是其他原因的暂停
 *    ontimeupdate: function () {},     // 网页元素的currentTime属性改变时触发。
 *    onvolumechange: function () {},   // 音量改变时触发（包括静音）。
 *    onwaiting: function () {},        // 由于另一个操作（比如搜索）还没有结束，导致当前操作（比如播放）不得不等待。
 }}
*/
const AudioPlayer = function (audioItems, options) {
    const player = this._createPlayer()

    if (typeof options === 'object') {
        const supportedEvents = this.supportedEvents()
        for (let i = 0; i < supportedEvents.length; i += 1) {
            if (typeof options[supportedEvents[i]] === 'function') {
                player[supportedEvents[i]] = options[supportedEvents[i]]
            }
        }
    }
    this.$ = {
        list: audioItems || [],
        playingIndex: 0,
        player
    }
}

AudioPlayer.prototype._playerType = function () {
    this.__isIphone = this.__isIphone || navigator.userAgent.toLowerCase().indexOf('iphone') != -1
    return this.__isIphone ? 'dom' : 'object'
}

AudioPlayer.prototype._createDomPlayer = function () {
    const container = document.createElement('div')
    container.setAttribute('style', 'display: none')
    const audio = document.createElement('audio')
    const audioId = '__zenjs_audioPlayer_01'
    audio.setAttribute('id', audioId)
    container.appendChild(audio)
    document.getElementsByTagName('body')[0].appendChild(container)
    return document.getElementById(audioId)
}

AudioPlayer.prototype._createObjectPlayer = function () {
    return new Audio()
}

AudioPlayer.prototype._createPlayer = function () {
    const type = this._playerType()

    if (type === 'object') {
        return this._createObjectPlayer()
    }

    return this._createDomPlayer()
}

AudioPlayer.prototype._playOnDomPlayer = function (audio) {
    let type = ''
    const types = {
        '.webm': 'audio/webm',
        '.wav': 'audio/wav',
        '.oga': 'audio/ogg',
        '.ogg': 'audio/ogg',
        '.mp1': 'audio/mpeg',
        '.mp2': 'audio/mpeg',
        '.mp3': 'audio/mpeg',
        '.mpg': 'audio/mpeg',
        '.mpeg': 'audio/mpeg',
        '.mp4': 'audio/mp4',
        '.m4a': 'audio/mp4',
        '.aac': 'audio/aac'
    }
    const defaultType = types['.mp3']
    if (audio.extensionName && types[audio.extensionName]) {
        type = types[audio.extensionName]
    } else {
        for (const key in types) {
            if (audio.src.indexOf(key) > 0) {
                type = types[key]
                break
            }
        }
        type = type || defaultType
    }

    let source = document.createElement('source')
    source.setAttribute('src', audio.src)
    source.setAttribute('type', type)
    if (audio.title) {
        source.setAttribute('title', audio.title)
    }
    let player = this.$.player
    player.pause()
    player.currentTime = 0
    if (player.firstChild) {
        player.removeChild(player.firstChild)
    }
    player.appendChild(source)
    player.load()
    player = undefined
    source = undefined
}

AudioPlayer.prototype._playOnObjectPlayer = function (audio) {
    const player = this.$.player
    player.pause()
    player.currentTime = 0
    player.src = audio.src
    if (audio.title) {
        player.title = audio.title
    }
}

AudioPlayer.prototype.supportedEvents = function () {
    return [
        'onloadstart',
        'ondurationchange',
        'onloadedmetadata',
        'onloadeddata',
        'onprogress',
        'oncanplay',
        'oncanplaythrough',
        'onabort',
        'onemptied',
        'onended',
        'onerror',
        'onpause',
        'onplay',
        'onplaying',
        'onratechange',
        'onseeked',
        'onseeking',
        'onstalled',
        'onsuspend',
        'ontimeupdate',
        'onvolumechange',
        'onwaiting'
    ]
}

// 以新的 audioItems 重置现有的 audioItems
AudioPlayer.prototype.flushAudioItems = function (audioItems) {
    this.$.list = audioItems
}

AudioPlayer.prototype.playingAudio = function () {
    return this.$.list[this.$.playingIndex]
}

AudioPlayer.prototype.playingIndex = function () {
    return this.$.playingIndex
}

AudioPlayer.prototype.isPlayingTheFirstOne = function () {
    return this.$.playingIndex === 0
}

AudioPlayer.prototype.isPlayingTheLastOne = function () {
    return this.$.playingIndex === this.$.list.length - 1
}

// 播放指定索引处的音频(内部方法)
// @param suspend - 是否暂停播放
AudioPlayer.prototype._play = function (index, suspend) {
    const $ = this.$
    if (typeof index !== 'number' || index < 0 || index >= $.list.length) {
        throw new Error('Unsupported `index`')
    }
    $.playingIndex = index
    const audio = $.list[$.playingIndex]
    const type = this._playerType()
    if (type === 'object') {
        this._playOnObjectPlayer(audio)
    } else {
        this._playOnDomPlayer(audio)
    }
    if (suspend) {
        $.player.pause()
    } else {
        $.player.play()
    }
}

// 播放指定索引处的音频, 参数 index 为空则默认 index = 0; 如果 index 超出 this.instance.list 的范围, 则从第一首开始播放
// @param suspend - 是否暂停播放
AudioPlayer.prototype.play = function (index, suspend) {
    if (typeof index === 'undefined' && this.$.player.paused) {
        return this.$.player.play()
    }

    if (typeof index !== 'number' || index < 0 || index >= this.$.list.length) {
        index = 0
    }

    this._play(index, suspend)
}

// 播放下一首; 如果当前正在播放音频列表的最后一首, 则播放音频列表的第一首
// @param suspend - 是否暂停播放
AudioPlayer.prototype.next = function (suspend) {
    this.play(this.$.playingIndex + 1, suspend)
}

// 播放上一首; 如果当前正在播放音频列表的第一首, 则播放音频列表的最后一首
// @param suspend - 是否暂停播放
AudioPlayer.prototype.prev = function (suspend) {
    this.play(this.$.playingIndex === 0 ? this.$.list.length - 1 : this.$.playingIndex - 1, suspend)
}

// 停止播放
AudioPlayer.prototype.pause = function () {
    this.$.player.pause()
}

// 重新加载当前正在播放的音频
AudioPlayer.prototype.load = function () {
    this.$.player.load()
}

// 是否静音; 如果参数为空, 返回当前播放音频的 muted 属性
AudioPlayer.prototype.muted = function (muted) {
    if (typeof meted === 'boolean') {
        this.$.player.muted = muted
    } else {
        return this.$.player.muted
    }
}

// 设置音量; 如果参数为空, 返回当前播放音频的 volume 属性: 0 ~ 1
AudioPlayer.prototype.volume = function (volume) {
    if (typeof volume === 'undefined') {
        return this.$.player.volume
    }

    if (typeof volume !== 'number') {
        throw new Error('Invalid `volume`')
    }
    volume = volume < 0 ? 0 : volume
    volume = volume > 1 ? 1 : volume
    this.$.player.volume = volume
}

// 从指定时间(单位为秒)播放; 如果参数为空, 返回当前播放音频的 currentTime 属性
AudioPlayer.prototype.currentTime = function (time) {
    if (typeof time === 'number') {
        this.$.player.currentTime = time
        this.$.player.play()
    } else {
        return this.$.player.currentTime
    }
}

// 指定播放速度; 将会覆盖 AudioPlayer 初始化时, 传入的音频列表每个音频所设置的播放速度选项; 若果参数为空, 返回当前播放音频的 playbackRate 属性
AudioPlayer.prototype.playbackRate = function (playbackRate) {}

// 是否进行缓冲加载; 将会覆盖 AudioPlayer 初始化时, 传入的音频列表每个音频所设置的缓冲加载选项; 如果参数为空, 返回当前播放音频是否启用 autobuffer
AudioPlayer.prototype.autobuffer = function (autobuffer) {}

// 是否循环播放; 将会覆盖 AudioPlayer 初始化时, 传入的音频列表每个音频所设置的循环播放选项; 如果参数为空, 返回当前播放音频的 loop 属性
AudioPlayer.prototype.loop = function (looped) {}

// 返回已经播放的时间段
AudioPlayer.prototype.played = function () {}

// 返回当前已经缓冲的时间段
AudioPlayer.prototype.buffered = function () {}

// 返回当前播放器需要跳到的时间段
AudioPlayer.prototype.seekable = function () {}

// 返回当前音频的 ready 状态
// readyState属性指定当前已经加载了多少媒体内容，只读属性:
// HAVE_NOTHING（数字值为0）:      没有获取到媒体的任何信息，当前播放位置没有可播放数据。
// HAVE_METADATA（数字值为1）:     已经获取到足够的媒体数据，但是当前播放位置没有有效的媒体数据（也就是说，获取到的媒体数据无效，不能播放）。
// HAVE_CURRENT_DATA（数字值为2）: 当前播放位置已经有数据可以播放，但没有获致到可以让播放器前进的数据。
//                               当媒体为视频时，意思是当前帖的数据已获取，但没有获取到下一帧的数据，或者当前帧已经是播放的最重一帧。
// HAVE_FUTURE_DATA（数字值为3）:  当前播放位置已经有数据可以播放，而且也获取到了可以让播放器前进的数据。
//                               当媒体为视频时，意思是当前帧的数据已获取，而且也获取到了下刺目贩数据，当前帧是播放的最后一帧时,
//                               readyState属性不可能为HAVE_FUTURE_DTAT。
// HAVE_ENOUGH_DATA（数字值为4）:  当前播放位置已经有数据可以播放，同时也获取到了可以让播放器前进的数据，而且浏览器确认媒体以某一种速度进行加载，
//                               可以保证有足够的后续数据进行播放。
AudioPlayer.prototype.readyState = function () {}

// 返回当前播放音频的 network 状态
// networkState属性读取当前的网络状态，共有如下所示的4个可能值：
// NETWORK_EMPTY（数字值为0）：元素牌初始状态。
// NETWORK_IDLE（数字值为1）：浏览器已选择好用什么编码格式来播放媒体，但尚未建立网络连接。
// NETWORK_LOADING（数字值为2）：媒体数据加载中。
// NETWORK_NO_SOURCE（数字值为3）：没有支持的编码格式，不执行加载。
AudioPlayer.prototype.networkState = function () {}

// 返回当前播放音频的(如果有)错误代码
// 当在加载媒体或者播放媒体过程中发生错误时，浏览器就会设置:
// MEDIA_ERR_ABORTED(数字值为1）：媒体数据的下载过程由于用户的操作原因而被中止。
// MEDIA_ERR_NETWORK(数字值为2）：确认媒体资源可用，但是在下载时出现网络错误，媒体数据下载过程被中止。
// MEDIA_ERR_DECODE(数字值为3)：确认媒体资源可能，但是解码时发生错误。
// MEDIA_ERR_SRC_NOT_SUPPORTED（数字值为4）：媒体格式不被支持。
AudioPlayer.prototype.error = function () {}

// 测试浏览器是否支持指定的媒体类型; mimeType 是媒体的 MIME 类型
// 如果它不能播放该类型的媒体文件，将返回一个空的字符串；反之，它会返回一个字符串：“maybe”或“probably”
AudioPlayer.prototype.canPlayType = function (mimeType) {}


// 整个媒体文件的播放时长，以秒为单位。如果无法获取时长，则返回NaN
AudioPlayer.prototype.duration = function () {
    return this.$.player.duration
}


// 如果媒体文件当前被暂停，则返回true。如果还未开始播放，默认返回true
AudioPlayer.prototype.paused = function () {
    return this.$.player.paused
}

// 如果媒体文件已经播放完毕，则返回true
AudioPlayer.prototype.ended = function () {
    return this.$.player.ended
}

// 返回最早的播放起始时间，一般是0.0，除非是缓冲过的媒体文件，并且一部分内容已经不在缓冲区
AudioPlayer.prototype.startTime = function () {
    return this.$.player.startTime
}

// 以字符串形式返回当前正在播放或已加载的文件。对应于浏览器在source元素中选择的文件
AudioPlayer.prototype.currentSrc = function () {
    return this.$.player.currentSrc
}

// 如果播放器正在跳到一个新的播放点，那seeking的值为true。
AudioPlayer.prototype.seeking = function () {
    return this.$.player.seeking
}

// 媒体的开始时间，单位为秒
AudioPlayer.prototype.initialTime = function () {
    return this.$.player.initialTime
}


export default AudioPlayer
